import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { getBoxes, getBoxById, BoxQueryParams } from '../api/boxApi'

export const useBoxes = (params: BoxQueryParams = {}) => {
  return useInfiniteQuery({
    queryKey: ['boxes', params],
    queryFn: ({ pageParam = 1 }) => getBoxes({ ...params, page: pageParam }),
    getNextPageParam: lastPage => {
      if (lastPage.meta.totalPages <= lastPage.meta.page) {
        return undefined
      }
      return lastPage.meta.page + 1
    },
    initialPageParam: 1,
    refetchInterval,
  })
}

export const useBoxById = (id: string) => {
  return useQuery({
    queryKey: ['box', id],
    queryFn: () => getBoxById(id),
    refetchInterval,
  })
}

const refetchInterval = 1000 * 5 // Refetch every 5 seconds
